module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL4AAAA8BAMAAAAqIh19AAAAG1BMVEVHcEzNZf/NZf/NZf/NZf/NZf/NZf/NZf/NZf/0B5m2AAAACHRSTlMA4y2oh8JSbFDm8p0AAADtSURBVFjD7dgxC4JAGMbxJ+sDZBI4moS0FtYcNNgaJTRL4SoY0dgR0X3sLGhIMCzvmXr/H+B3vnc6nAByV3NSMxQNNK8eYGlmHlpUv4sT1b9hS/UvcKm+guYmvvjiiy+++OKLL7744v+Rz76/cO9fVyzJ98cR1T+jQ/UzUA/gAqBN9OePHyh7Gj/Bs+GYojsZXlm7qeHvzIk8vBcsVqY+2s2xjJsbox8m+FSTMdS64sFNjNGPEtQvyL8ZQ4W1Hrw0Rlprq9Q68vFrxRru59cwQdP8iuMobA+GCg5vaxR7ksB0frqIbW3H4fGL/b4Dunud01JIrxYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/common/lesson-three.png
// module id = 629
// module chunks = 1